import useLocale from './use-locale';
import { BookingLocalization } from '../Utils/graphql-sdk';
import useShopForPageType from './use-shop-for-page-type';

export const useGetCustomBookingLocalization = () => {
  const shop = useShopForPageType();

  const { languageAsEnum } = useLocale();

  const getCustomBookingLocalization = (localization: BookingLocalization) => {
    return shop?.bookingLocalizations?.[localization]?.[languageAsEnum];
  };

  return getCustomBookingLocalization;
};
